<template>
  <v-card>
    <v-card-text class="overflow-y-auto wh-600">
      <v-container>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-text-field
              v-model="term"
              :label="$t('Search products by name')"
              prepend-inner-icon="search"
              @input="handleSearch"/>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="products"
              :rows-per-page-text="$t('Rows per page')"
              :pagination.sync="pagination"
              :total-items="total"
              class="elevation-1"
              item-key="id"
            >
              <v-progress-linear
                slot="progress"
                color="primary"
                indeterminate
              />

              <template v-slot:items="props">
                <tr
                  class="pointer"
                  @click="$emit('add-product', props.item)">
                  <td>{{ props.item.sku }}</td>
                  <td>{{ props.item.name }}</td>
                </tr>
              </template>
              <template v-slot:pageText="props">
                <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="darken-1"
        flat
        small
        @click="$emit('closed')"
      >
        {{ $t('Close') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ProductService from '@/modules/Products/service'
import debounce from 'lodash.debounce'

export default {
  name: 'ProductSingleSelectComponentDialog',

  data () {
    return {
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'name'
      },
      total: 0,
      term: '',
      loading: false,
      products: [],
      handleSearch: null
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('SKU'), value: 'sku' },
        { text: this.$t('Name'), value: 'name' }
      ]
    }
  },

  watch: {
    pagination: function () {
      this.getProducts()
    }
  },

  created () {
    this.handleSearch = debounce(this.search, 700)
  },

  methods: {
    async getProducts () {
      this.loading = true
      const res = await ProductService.loadOnlyCommonProducts(this.pagination)
      this.products = res.collection
      this.total = res.page.total
      this.loading = false
    },

    async search (term) {
      this.loading = true
      const res = await ProductService.searchCommonProducts(this.pagination, this.term)
      this.products = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
